import React from 'react';
import styles from './FormField.module.css';

export default function FormField({
  label,
  helper = '',
  htmlFor = '',
  className = '',
  children,
}) {
  return (
    <div className={`${styles.field} ${className}`.trim()}>
      {label ? <label className={styles.label} htmlFor={htmlFor || undefined}>{label}</label> : null}
      {children}
      {helper ? <p className={styles.helper}>{helper}</p> : null}
    </div>
  );
}
